module.exports = __webpack_public_path__ + "static/media/rannis.70fd18ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Landing/rannis.png
// module id = 110
// module chunks = 0